/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Bio6Inputs */

const en__field_enum_mzs_bio6 = /** @type {(inputs: _Field_Enum_Mzs_Bio6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`biology`)
};

const de__field_enum_mzs_bio6 = /** @type {(inputs: _Field_Enum_Mzs_Bio6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biowissenschaften`)
};

/**
* | output |
* | --- |
* | "biology" |
*
* @param {_Field_Enum_Mzs_Bio6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_bio6 = /** @type {((inputs?: _Field_Enum_Mzs_Bio6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Bio6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_bio6(inputs)
	return de__field_enum_mzs_bio6(inputs)
});
export { _field_enum_mzs_bio6 as "_field_enum_MZS_BIO" }